import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { CheckoutState } from '@app/service/state/state.service';
import { PaymentMethod } from '@app/model/payment-request/payment-request.dto';

@Component({
  selector: 'app-de-tokenized-onboarding-success',
  templateUrl: './de-tokenized-onboarding-success.component.html',
  styleUrls: [
    '../../../../route/page-shared.css',
    './de-tokenized-onboarding-success.component.scss',
  ],
})
export class DeTokenizedOnboardingSuccessComponent implements OnInit {
  @Output() onDetailsClick = new EventEmitter();
  @Input() params: any;
  @Input() state: CheckoutState;
  @Input() isWaitingForUpdate: boolean;
  @Input() hasSuccessRouteFailed: boolean;
  @Input() email: string = '';

  successRouteFailedHeading: string = 'Danke für Ihren Kauf!';
  successRouteFailedSubHeading: string = 'Wir senden Ihre Rechnung an: ';

  paymentMethodText: string = 'Monatsrechnung';
  parameterizedSubHeading: string;

  ngOnInit() {
    if (
      this.state?.paymentInformation?.paymentMethod ===
      PaymentMethod.INSTANT_DEBIT_INVOICE
    ) {
      this.paymentMethodText = 'Direktzahlung per Bankeinzug';
    }

    this.parameterizedSubHeading = this.getParameterizedSubHeading();
  }

  detailsClick(): void {
    this.onDetailsClick.emit();
  }

  getParameterizedSubHeading(): string {
    return this.params.subHeading
      .replace('${MERCHANT}', this.state?.checkoutCustomizations?.merchantName)
      .replace('${METHOD}', this.paymentMethodText);
  }
}
